const modalOverrides = {
    dismissHTML: "X",
    dismissStyle: {
        color: "#fff",
        fontSize: "25px"
    },
    style: {
        background: "#8f38de",
        color: "#fff",
        padding: "2em 3.5em",
        borderRadius: "10px",
        height: "48vh",
        width: "43%"
    }
}

const largeVideoModal = {
    dismissHTML: "X",
    dismissStyle: {
        background: "rgb(255 89 89)",
        width: "4%",
        textAlign: "center",
        borderRadius: "0px 10px 0px 10px",
        right: "0%",
        fontSize: "25px"
    },
    style: {
        overflow: "hidden",
        borderRadius: "10px",
        top: "-6.5%",
        left: "-.5%",
        aspectRatio: "16/9",
        background: "#000",
        width: "70.7%"
    }
}

const textModal = (width = "80%", center = false) => {
    let m = {
        dismissHTML: "X",
        dismissStyle: {
            color: "#fff",
            fontSize: "25px"
        },
        style: {
            textAlign: center ? "center" : "left",
            background: "#8f38de",
            color: "#fff",
            padding: "2em 3.5em",
            borderRadius: "10px",
            minWidth: "500px",
            width
        }
    }
    return m
}

const ModalVideo = ({url}) => {
    return <div style={{width: "100%", height: "100%"}}>
        <iframe src={`${url}&autoplay=1`}  width="100%" height="100%" frameBorder="0" autoPlay="true" webkitallowfullscreen mozallowfullscreen allowfullscreen/>
    </div>
}

export {
    modalOverrides, 
    textModal,
    ModalVideo,
    largeVideoModal
}

const Link = ({booth, title, href, children}) => 
    <a
        href={href}
        target="_blank"
        data-event-category={booth}
        data-event-action="Link Click" 
        data-event-label={title}
        title={title}
        aria-label={title}
        style={{textDecoration: "underline"}}
        class="_gtm-event"
    >
        { children ? children : "Company site" }
    </a>

const images = {
    facebook: "https://assets.swoogo.com/uploads/full/2170290-6362abd788e78.png",
    twitter: "https://assets.swoogo.com/uploads/2170291-6362abd7b6739.svg",
    instagram: "https://assets.swoogo.com/uploads/full/2170294-6362abd9bd583.png",
    linkedin: "https://assets.swoogo.com/uploads/full/2170292-6362abd7b663c.png",
    youtube: "https://assets.swoogo.com/uploads/2170395-6362b2c5ce2cb.svg"
}

const imageCss = {
    width: "60px",
    height: "auto",
    margin: "0 10px"
}

export const sponsorModal = (booth, name, text = "", links) => {
    
    const socialMedia = Object.keys(links).filter(x => x !== "company").map(key => {
        return <Link booth={booth} title={name} href={links[key]}>
            <img style={imageCss} src={images[key]} />
        </Link>
    })

    return <div style={{height: "100%", width: "100%", textAlign: "center", fontWeight: "bold"}}>
        { text }
        {links.company ? <p><Link booth={booth} title={name} href={links.company}/></p> : null }
        { socialMedia.length > 0 ? socialMedia : null}
        { links.contactUs ? <p><Link booth={booth} title={name} href={links.contactUs}>Contact Us</Link></p> : null }
    </div>
}